module.exports = __webpack_public_path__ + "img/fs_wuji.d62904c6.png";